import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export const Text = styled(MDSText.HeroSm)`
  max-width: 49.5rem;
`;
export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;
